import { useRef } from "preact/hooks";

// Remounts when the value changes, so the CSS pop plays then and not on the first paint.
export function Pop({ value, class: className = "" }: { value: string | number; class?: string }) {
	const previous = useRef(value);
	const changed = previous.current !== value;
	previous.current = value;
	return (
		<span key={value} class={`inline-block ${className}${changed ? " cs-pop" : ""}`}>
			{value}
		</span>
	);
}

// `track`: the dark empty part, darker than the default on the header's brown band.
export function Bar({ percent, color, label, track = "dark:bg-line-strong" }: { percent: number; color: string; label: string; track?: string }) {
	const width = Math.max(0, Math.min(100, Math.round(percent)));
	return (
		<div
			class={`h-2 min-w-0 flex-1 overflow-hidden rounded-full bg-cinza-200 ${track}`}
			role="progressbar"
			aria-label={label}
			aria-valuemin={0}
			aria-valuemax={100}
			aria-valuenow={width}
		>
			<div class={`cs-bar h-full rounded-full ${color}`} style={{ width: `${width}%` }} />
		</div>
	);
}

const MARK = "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border";

// A use box, filled when spent; a button when the viewer may change it.
export function Mark({ on, label, onToggle }: { on: boolean; label: string; onToggle?: ((used: boolean) => void) | null }) {
	const look = `${MARK} ${on ? "border-carmesim-600 bg-carmesim-600 text-white" : "border-line-strong bg-surface-sunken"}`;
	const tick = on && <span class="block h-2.5 w-1.5 rotate-45 border-b-2 border-r-2 border-white" />;
	if (!onToggle) {
		return (
			<span role="img" aria-label={label} class={look}>
				{tick}
			</span>
		);
	}
	return (
		<button type="button" aria-pressed={on} aria-label={label} class="cs-tap" onClick={() => onToggle(!on)}>
			<span class={look}>{tick}</span>
		</button>
	);
}
